module.exports = __webpack_public_path__ + "images/7bff16be690d180b1ea6706935f585ae.discard.png";